import styled from "styled-components";
import { palette } from "styled-theme";

const ModalContentWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  .top {
    border-bottom: 1px solid ${palette("border", 0)};
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: center;
    padding: 16px;
  }
  .closeBtn {
    position: absolute;
    left: ${(props) => (props["direction"] === "rtl" ? "10px" : "inherit")};
    right: ${(props) => (props["direction"] === "ltr" ? "10px" : "inherit")};
  }
  .inner {
    padding: 20px;
  }
  .actions {
    padding: 20px 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .horizontal-divider {
    width: 20px;
  }
  .vertical-divider {
    height: 20px;
  }
  .ant-button-link > span {
    color: inherit;
    text-decoration: underline;
  }
`;

export default ModalContentWrapper;
